/* T-243: 予約限定クーポン（YOYAKU3000）の自動適用。
   対象商品（stoq-vacuum-set）がカートに入っている、または対象商品のPDPを閲覧している顧客に対し、
   Shopify標準の割引セッションURL /discount/<code> を same-origin fetch で裏叩きし、
   コード入力なしでチェックアウト時に割引が反映された状態にする。

   発火対象は data-stoq-auto-coupon 属性を持つ要素（コードはliquid側のassignから渡す＝
   このJSにコードをハードコードしない一元管理。属性の出し元は下記2snippet）:
   - snippets/stoq-preorder-notice.liquid（PDP。対象商品ページなら閲覧時点で発火）
   - snippets/stoq-preorder-cart-note.liquid（カート行。cart-drawer.liquid / main-cart-items.liquid
     の両方から呼ばれるため、カートページ・カートドロワーいずれでも発火する）

   本ファイルは全ページ（layout/theme.liquid）で読み込まれる想定。対象要素が現在DOM上に無く、かつ
   カートドロワー要素（#CartDrawer。cart_type=drawer設定のとき常時レンダリングされる）も無いページでは、
   MutationObserverの設置も含め一切何もしない（fetchはもちろん、監視すら発生しない）。
   カートドロワーが存在するページでは、Ajax再描画（カート追加でドロワーに対象商品行が新規に現れる等）を
   検知するため #CartDrawer 配下（document全体ではない）に限定した軽量なMutationObserverを設置し、
   検知対象のコードが「適用成功」または「適用試行済み（失敗含む）」になった時点で必ずdisconnectする
   （常設しない）。

   多重発火防止は二段構え:
   1) モジュールスコープのメモリ内フラグ（attempted）: このページ滞在中は同一コードを二度と
      fetchしない。sessionStorageが使えない環境（プライベートブラウズ等）でもここで構造的に防止される。
   2) sessionStorage（stoqAutoCouponApplied:<code>）: ページをまたいで「既に成功済み」を記憶し、
      別ページ遷移後の再フェッチを避ける（＝毎PV発火させない）。fetchが成功（response.ok）した
      場合のみ書き込む。失敗時は書き込まない＝次のページ遷移時にこのファイルが再読込された際、
      あらためて試行される（自然リトライ。ページ内での即時リトライはしない）。

   失敗しても無害：/discount/<code> の裏叩きが失敗しても、カート/チェックアウトの見た目や
   購入導線は一切変わらない（従来どおりコード欄への手入力フォールバックが効く）。UIは一切変更しない。 */
(function () {
  'use strict';

  var SELECTOR = '[data-stoq-auto-coupon]';
  var STORAGE_KEY_PREFIX = 'stoqAutoCouponApplied:';
  var DRAWER_ROOT_ID = 'CartDrawer';

  // このページ滞在中に「試行済み（成功・失敗いずれか確定 or 試行中）」となったコードの集合。
  // sessionStorageの可否に関わらず、同一ページ内での多重fetchを構造的に防ぐためのメモリ内フラグ。
  var attempted = {};
  var observer = null;

  function persistedApplied(code) {
    try {
      return window.sessionStorage.getItem(STORAGE_KEY_PREFIX + code) === '1';
    } catch (e) {
      // sessionStorageが使えない環境。attempted（メモリ内フラグ）で同一ページ内の多重fetchは防げるが、
      // ページをまたいだ「既に成功済み」の記憶はできない＝別ページでは改めて試行される（無害な再fetchのみ）。
      return false;
    }
  }

  function markPersistedApplied(code) {
    try {
      window.sessionStorage.setItem(STORAGE_KEY_PREFIX + code, '1');
    } catch (e) {
      // 保存できなくても致命的ではない（上記の通り、無害な再fetchが起こり得るだけ）
    }
  }

  function hasPendingWork() {
    // 現在DOM上にある対象要素のうち、まだ「試行済み」でないコードが残っているか
    var nodes = document.querySelectorAll(SELECTOR);
    for (var i = 0; i < nodes.length; i++) {
      var code = nodes[i].getAttribute('data-stoq-auto-coupon');
      if (code && !attempted[code]) return true;
    }
    return false;
  }

  function stopWatchingIfDone() {
    if (!observer) return;
    // 「まだ一度も試行していない（＝対象要素がまだ一度も現れていない）」だけでは監視をやめない
    // （ドロワー内の無関係なDOM変化のたびに誤って早期disconnectしてしまうのを防ぐため）。
    // 実際に何かしら試行した実績があり、かつ現在DOM上に未試行の対象が残っていない場合のみ止める。
    var attemptedAny = false;
    for (var code in attempted) {
      if (Object.prototype.hasOwnProperty.call(attempted, code)) {
        attemptedAny = true;
        break;
      }
    }
    if (attemptedAny && !hasPendingWork()) {
      observer.disconnect();
      observer = null;
    }
  }

  function applyCoupon(code) {
    if (!code || attempted[code]) return;
    if (persistedApplied(code)) {
      attempted[code] = true;
      return;
    }
    // fetch開始前に必ず立てる：PDP＋カートドロワーが同一ページに同時存在する等、複数要素が
    // 同じコードを持っていても、このページ滞在中は一度しかfetchしない（成功/失敗を問わない）。
    attempted[code] = true;

    fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' })
      .then(function (response) {
        // 成功時（response.ok）のみ永続フラグを立てる。失敗時は立てないため、
        // 次のページ遷移でこのファイルが再読込された際にあらためて試行される（自然リトライ）。
        if (response && response.ok) {
          markPersistedApplied(code);
        } else {
          console.error('[stoq-auto-coupon] coupon session apply responded not-ok:', response && response.status);
        }
      })
      .catch(function (err) {
        // 失敗しても無害：UIには一切影響させない（フォールバックはコード手入力）。
        console.error('[stoq-auto-coupon] failed to apply coupon session:', err);
      })
      .then(stopWatchingIfDone);
  }

  function scan(root) {
    var nodes = (root || document).querySelectorAll(SELECTOR);
    for (var i = 0; i < nodes.length; i++) {
      applyCoupon(nodes[i].getAttribute('data-stoq-auto-coupon'));
    }
  }

  function init() {
    scan(document);

    var drawerRoot = document.getElementById(DRAWER_ROOT_ID);
    if (!drawerRoot || !window.MutationObserver) return; // 監視必要要素（ドロワー）が無いページでは何もしない

    // 初期scanの時点で対象要素が無くても（＝カートが空、または対象商品が未投入）、このページの
    // 滞在中にAjaxでカートへ追加され、ドロワーの再描画で対象商品行が新規に現れる可能性があるため、
    // ドロワーが存在する限りは監視を開始する。監視範囲は #CartDrawer 配下のみ（documentElement全体は見ない）。
    // 実際に対象コードの適用を試行（成功/失敗いずれか確定）した時点で stopWatchingIfDone() が呼ばれ、
    // 他に未試行の対象が残っていなければ即disconnectする（常時張りっぱなしにはしない）。
    observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes && mutations[i].addedNodes.length) {
          scan(drawerRoot);
          break;
        }
      }
      stopWatchingIfDone();
    });
    observer.observe(drawerRoot, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
